// import React, { useCallback, useEffect, useState } from "react";
// import CustomModal from "../../../../components/modal/CustomModal";
// import { Divider, Flex, Input, Space } from "antd";
// import { IconAlertSquareRounded } from "@tabler/icons-react";
// import CustomTextarea from "../../../../components/input/CustomTextarea";
// import api from "../../../../api";
// import { useToast } from "../../../../components/toast/toast";

// const StatementModal = ({ visible, onClose, setSelectedStatement }) => {
//   const [comment, setComment] = useState("");
//   const [submitting, setSubmitting] = useState(false);
//   const toast = useToast();
//   const [statements, setStatements] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [filters, setFilters] = useState({
//     account_number: "",
//     related_account: "",
//     description: "",
//   });
//   const [total, setTotal] = useState(0);
//   const [page, setPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);

//   const fetchStatements = useCallback(async (params) => {
//     setIsLoading(true);
//     const res = await api.get_all_bank_statements(params);
//     console.log("res --->", res);
//     if (res.status === 200) {
//       setStatements(res.data.data);
//       setTotal(res.data.total);
//     } else {
//       toast(res.data?.message || "Алдаа гарлаа", "error");
//     }
//     setIsLoading(false);
//   }, []);

//   // Анх болон page, pageSize, filters өөрчлөгдөхөд дуудаж байна
//   useEffect(() => {
//     fetchStatements({
//       page,
//       limit: pageSize,
//       ...filters,
//     });
//   }, [fetchStatements, page, pageSize, filters]);

//   // Анх болон page/filter өөрчлөгдөхөд татна
//   const onFilterChange = (key) => (e) => {
//     const value = e.target.value;
//     const newFilters = { ...filters, [key]: value };
//     setFilters(newFilters);
//     setPage(1); // Шинэ filter → хуудас 1-рүү буцаах
//   };

//   const reset = () => setComment("");

//   const handleCancel = () => {
//     if (submitting) return;
//     reset();
//     onClose?.();
//   };

//   const handleOk = async () => {
//     // if (!complaintId || !comment) return;
//     // try {
//     //   setSubmitting(true);
//     //   const res = await api.reject_complaint(complaintId, { comment });
//     //   if (res?.status === 200) {
//     //     toast?.("Гомдлыг татгалзлаа.", "success");
//     //     reset();
//     //     onClose?.();
//     //     onSuccess?.();
//     //   } else {
//     //     const msg =
//     //       res?.data?.errors?.comment || res?.data?.message || "Алдаа гарлаа";
//     //     toast?.(msg, "error");
//     //   }
//     // } catch (e) {
//     //   toast?.(e?.response?.data?.message || "Серверийн алдаа", "error");
//     // } finally {
//     //   setSubmitting(false);
//     // }
//   };

//   return (
//     <CustomModal
//       open={visible}
//       title="Татгалзах"
//       onCancel={handleCancel}
//       onOk={handleOk}
//       disabled={!comment || submitting}
//     >
//       <Flex vertical gap={10}>
//         <Space style={{ marginBottom: 16 }}>
//           <Input
//             style={{ width: 180 }}
//             placeholder="Холбогдох данс"
//             value={filters.related_account}
//             onChange={onFilterChange("related_account")}
//             allowClear
//           />
//           <Divider type="vertical" />
//           <Input
//             style={{ width: 180 }}
//             placeholder="Гүйлгээний утга"
//             value={filters.description}
//             onChange={onFilterChange("description")}
//             allowClear
//           />
//         </Space>
//       </Flex>
//     </CustomModal>
//   );
// };

// export default StatementModal;

import React, { useCallback, useEffect, useMemo, useState } from "react";
import CustomModal from "../../../../components/modal/CustomModal";
import { Table, Tag, Button, Flex, Input, Space, Divider, Empty } from "antd";
import api from "../../../../api";
import { useToast } from "../../../../components/toast/toast";

const StatementModal = ({ visible, onClose, setSelectedStatement }) => {
  const toast = useToast();

  const [filters, setFilters] = useState({
    related_account: "",
    description: "",
  });
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);

  // Хэрэглэгч "Хайх" дарсан эсэх — анх table харагдахгүй
  const [hasSearched, setHasSearched] = useState(false);

  const hasQuery = useMemo(() => {
    const { related_account, description } = filters || {};
    return Boolean(
      (related_account && related_account.trim()) ||
        (description && description.trim())
    );
  }, [filters]);

  const fetchStatements = useCallback(
    async (params) => {
      setLoading(true);
      try {
        const res = await api.get_all_bank_statements(params);
        if (res.status === 200) {
          setRows(res.data?.data || []);
          setTotal(res.data?.total || 0);
        } else {
          toast(res.data?.message || "Алдаа гарлаа", "error");
        }
      } catch (e) {
        toast(e?.response?.data?.message || "Серверийн алдаа", "error");
      } finally {
        setLoading(false);
      }
    },
    [toast]
  );

  const runSearch = useCallback(() => {
    if (!hasQuery) {
      setHasSearched(true);
      setRows([]);
      setTotal(0);
      return;
    }
    setHasSearched(true);
    fetchStatements({
      page,
      limit: pageSize,
      related_account: filters.related_account || undefined,
      description: filters.description || undefined,
    });
  }, [fetchStatements, filters, hasQuery, page, pageSize]);

  // Модал нээгдэх үед төлөвийг цэвэрлэнэ
  useEffect(() => {
    if (visible) {
      setRows([]);
      setTotal(0);
      setPage(1);
      setPageSize(10);
      setHasSearched(false);
      // filters-ийг хадгалж үлдээх бол доорхи 2 мөрийг комментлоорой
      setFilters({ related_account: "", description: "" });
    }
  }, [visible]);

  // Pagination өөрчлөгдвөл дахин хайна (зөвхөн өмнө нь хайлт хийсэн байвал)
  useEffect(() => {
    if (visible && hasSearched && hasQuery) {
      runSearch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, pageSize]);

  //   const onFilterChange = (key) => (e) => {
  //     const value = e.target.value;
  //     setFilters((f) => ({ ...f, [key]: value }));
  //   };

  const onFilterChange = (key) => (e) => {
    const value = e?.target?.value ?? "";
    setFilters((prev) => {
      const next = { ...prev, [key]: value };
      const hasAny =
        (next.related_account && next.related_account.trim()) ||
        (next.description && next.description.trim());

      if (!hasAny) {
        setRows([]);
        setTotal(0);
        setHasSearched(false);
        setPage(1);
      }
      return next;
    });
  };

  const handleSelect = (record) => {
    setSelectedStatement?.(record);
    onClose?.();
  };

  const columns = [
    {
      title: "Данс",
      dataIndex: "account_number",
      key: "account_number",
      width: 160,
    },
    {
      title: "Record ID",
      dataIndex: "record_id",
      key: "record_id",
      ellipsis: true,
    },
    {
      title: "Дүн",
      dataIndex: "amount",
      key: "amount",
      width: 120,
      render: (v) => <span>{Number(v).toLocaleString()}₮</span>,
    },
    {
      title: "Гүйлгээний утга",
      dataIndex: "description",
      key: "description",
      ellipsis: true,
    },
    {
      title: "Огноо",
      dataIndex: "date_at",
      key: "date_at",
      width: 180,
      render: (d) => new Date(d).toLocaleString(),
    },
    {
      title: "Үйлдэл",
      key: "action",
      width: 120,
      align: "center",
      render: (_, record) => (
        <Button
          type="link"
          style={{ fontSize: "12px" }}
          onClick={() => handleSelect(record)}
        >
          Сонгох
        </Button>
      ),
    },
  ];

  return (
    <CustomModal
      open={visible}
      title="Банкны хуулга сонгох"
      onCancel={onClose}
      footer={null}
      width={900}
    >
      <Flex vertical gap={12}>
        <Space style={{ marginBottom: 8 }} wrap>
          <Input
            style={{ width: 220 }}
            placeholder="Холбогдох данс"
            value={filters.related_account}
            onChange={onFilterChange("related_account")}
            allowClear
            onPressEnter={runSearch}
          />
          <Divider type="vertical" />
          <Input
            style={{ width: 220 }}
            placeholder="Гүйлгээний утга"
            value={filters.description}
            onChange={onFilterChange("description")}
            allowClear
            onPressEnter={runSearch}
          />
          <Button
            type="primary"
            onClick={runSearch}
            loading={loading}
            disabled={!hasQuery}
          >
            Хайх
          </Button>
        </Space>

        {/* Хоосон үед “Хайлт хийнэ үү” — table харагдахгүй */}
        {!hasSearched && (
          <Empty
            description="Хайлт хийнэ үү"
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            style={{ padding: "24px 0" }}
          />
        )}

        {/* Хайлт хийсний дараа л Table үзүүлнэ */}
        {hasSearched && (
          <Table
            rowKey={(r) => `${r.account_number}:${r.record_id}`}
            columns={columns}
            dataSource={rows}
            loading={loading}
            pagination={{
              current: page,
              pageSize,
              total,
              showSizeChanger: true,
              onChange: (p, ps) => {
                setPage(p);
                setPageSize(ps);
              },
            }}
            size="middle"
            locale={{
              emptyText: hasQuery ? (
                <Empty
                  description="Илэрц олдсонгүй"
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
              ) : (
                <Empty
                  description="Хайлт хийнэ үү"
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
              ),
            }}
          />
        )}
      </Flex>
    </CustomModal>
  );
};

export default StatementModal;
